var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"mt-5"},[_c('b-col',{attrs:{"sm":"12","md":"8","offset-md":"2","lg":"6","offset-lg":"3"}},[_c('h1',{staticClass:"text-center"},[_vm._v("PinPoint")]),_c('div',{staticClass:"alert",class:_vm.alertClass},[_vm._v(" "+_vm._s(_vm.message)+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }